import React from 'react';
import { FlagServiceSubscriber } from '@atlassian/jira-flags';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { NavigationItem } from '@atlassian/jira-navigation-types/src/types.tsx';
import Content from './content/index.tsx';
import AddRepositoryModal from './view.tsx';

const AddRepositoryModalWithIntl = injectIntl(AddRepositoryModal);

type Props = {
	projectId: string;
	baseUrl: string;
	onCompleted: (arg1: { item: NavigationItem | undefined }) => void;
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: Props) => (
	<FlagServiceSubscriber>
		{(flagService) => (
			<AddRepositoryModalWithIntl {...props} flagService={flagService} Content={Content} />
		)}
	</FlagServiceSubscriber>
);
